import React from 'react';
import { Helmet } from 'react-helmet';

// eslint-disable-next-line react/prop-types
const Header = ({ shopName, service, date }) => (
  <div className="u-pt-30 u-pr-4 u-pl-4 u-mb-4 u-text-small u-co-grey--light u-ta-center">
    <Helmet>
      <title>Reminder | {shopName}</title>
    </Helmet>
    You are scheduled for a {service} {date}
  </div>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/notifications/customer/CustomerReminder/components/Header.jsx